import apiClient from './api';
import { getApiAccessToken } from './UserService';

export interface ClientSystemSettings {
    [key: string]: string;
}

export async function getClientSystemSettings(addressSystemId: number): Promise<ClientSystemSettings> {
    try {
        const token = await getApiAccessToken();
        const response = await apiClient.get<ClientSystemSettings>(
            `/api/ClientSystemSettings/${addressSystemId}`,
            {
                headers: {
                    Authorization: `Bearer ${token}`
                }
            }
        );
        return response.data;
    } catch (error) {
        console.error('Failed to fetch client system settings:', error);
        return {};
    }
}
